/**
 * `crypto.randomUUID()` gibt es nur in sicheren Kontexten (HTTPS/localhost).
 * Der Dev-Server ist absichtlich im LAN erreichbar (siehe CLAUDE.md) – ein
 * Handy, das per `http://<lan-ip>:5173` testet, läuft in einem UNSICHEREN
 * Kontext und bekommt `crypto.randomUUID === undefined`. Jede Stelle, die
 * clientseitig IDs braucht, geht deshalb über diese Funktion statt direkt
 * über `crypto.randomUUID()`.
 */
export function uuid(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  // RFC-4122-ähnlich genug für lokale, nie über die API laufende IDs.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}
